<wiz-vgroup #vgDetailZone width="100%" height="100%" class="section-container" padding="5px">
  <wiz-hgroup
    #stepValidation
    wizValidationContainer
    width="100%"
    class="widget-header"
    [verticalAlign]="'center'"
    padding="5px">
  <wiz-icon class="image-purple">steps</wiz-icon>
    <wiz-text-input
    #tiStep
    width="100%"
    class="upper-case-input"
    [wizValidator]="uniqueStepCodeValidator()"
    [wizShowErrors]="true"
    [wizMandatory]="true"
    [wizMaxChars]="10"
  ></wiz-text-input>
  <wiz-icon (click)="askForEdit($event)" [wizTooltip]="'$.common.edit.$'" class="image-purple">icon-edit</wiz-icon>
  </wiz-hgroup>
  <wiz-label #vsLbl width="100%" [wizTextBehavior]="'truncate'" class="smallFont"></wiz-label>
  <wiz-list
    #lstStep
    width="100%"
    height="100%"
    [wizItemRenderer]="stepKeyRenderer"
    [wizLabelField]="'label'"
  ></wiz-list>
</wiz-vgroup>
